import React from 'react';
import ErrorFilledIcon from '../../../visuals/Icons/ErrorFilled';
import references from '../../../css-library/tokens/reference';
import { IconSizes } from '../../../visuals/Icons/type';
import { useTextInput } from '../TextInput/TextInput';

interface IErrorTextProps {
  children: React.ReactNode;
  dataTestId?: string;
}

export const ErrorText: React.FC<IErrorTextProps> = ({
  children,
  dataTestId = '',
}) => {
  const { isInvalid } = useTextInput();

  return (
    <span
      className={`tw-lf-form-input-bottom-message tw-grid-area-[text] ${
        isInvalid ? 'tw-flex' : 'tw-hidden'
      } group-[.text-input-action]:tw-ml-2 peer-[:not(:placeholder-shown)]:peer-invalid:tw-flex`}
      data-testid={dataTestId}
    >
      <ErrorFilledIcon color={references.colors.red[600]} size={IconSizes.sm} />
      <span className="tw-lf-input-error-message">{children}</span>
    </span>
  );
};
